import axios from 'axios'
import store from 'store'

const apiHoldingClient = axios.create({
	baseURL: `${process.env.VUE_APP_API_HOLDING_URL}`,
	timeout: 1000 * 50,
})

apiHoldingClient.interceptors.request.use((request) => {
	const accessToken = store.get('accessToken')
	if (accessToken) {
		request.headers = {
			...request.headers,
			Authorization: `Bearer ${accessToken}`,
		}
	}
	return request
})

export default apiHoldingClient
